<form #userForm="ngForm" (ngSubmit)="onSubmit()">
  <div class="profile-container">
    <div class="profile-header">
      <div>
        <h2 class="profile-title">Mi Perfil Mentor</h2>
        <p class="section-description">Phoenix Dashboard / Editar Perfil Mentor</p>
      </div>
      <div class="edit-toggle-container">
        <button type="submit" class="btn-save">
          Guardar
        </button>
      </div>
    </div>

    <!-- Sección de perfil -->
    <section class="section-header-container">
      <div class="profile-main-card">
        <!-- Card de la foto de perfil -->
        <div class="profile-photo-card">
          <div class="profile-photo" *ngIf="profileImageBase64">
            <img [src]="profileImageBase64" alt="Foto de perfil" />
            <div class="photo-upload-overlay">
              <input type="file" id="photoFile" name="photoFile" accept="image/*" (change)="onPhotoSelected($event)"
                #photoFileInput style="display: none;" />
              <button type="button" class="btn-upload-overlay" (click)="photoFileInput.click()">
                <i class="fa-solid fa-upload"></i>
              </button>
            </div>
          </div>
          <div class="profile-photo no-photo" *ngIf="!profileImageBase64">
            <i class="fa-solid fa-user"></i>
            <div class="photo-upload-overlay">
              <input type="file" id="photoFileNoImage" name="photoFileNoImage" accept="image/*"
                (change)="onPhotoSelected($event)" #photoFileNoImageInput style="display: none;" />
              <button type="button" class="btn-upload-overlay" (click)="photoFileNoImageInput.click()">
                <i class="fa-solid fa-upload"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- Card de información personal -->
        <div class="profile-info-card">
          <div class="card-header">
            <h3 class="card-title">Mi cuenta</h3>
          </div>

          <!-- Vista de edición -->
          <div class="edit-form" *ngIf="profileForm">
            <!-- Primera fila: Nombre y apellido | Profesión -->
            <div class="form-row">
              <div class="form-group">
                <label>Nombre y apellido <span class="required-asterisk">*</span></label>
                <input type="text" name="fullName" [formControl]="$any(profileForm.get('fullName'))" readonly class="form-input blocked"
                  placeholder="Nombre y Apellido bloqueado" />
              </div>
              <div class="form-group">
                <label>Profesión <span class="required-asterisk">*</span></label>
                <input type="text" name="profession" [formControl]="$any(profileForm.get('profession'))" class="form-input"
                  placeholder="Ingrese profesión" />
              </div>
            </div>

            <!-- Segunda fila: Correo electrónico | Número de celular -->
            <div class="form-row">
              <div class="form-group">
                <label>Correo electrónico <span class="required-asterisk">*</span></label>
                <input type="email" name="email" [formControl]="$any(profileForm.get('email'))" readonly class="form-input blocked"
                  placeholder="Correo electrónico bloqueado" />
              </div>
              <div class="form-group">
                <label>Número de celular <span class="required-asterisk">*</span></label>
                <input type="tel" name="phone" [formControl]="$any(profileForm.get('phone'))" class="form-input"
                  placeholder="Ingrese número de celular" pattern="[0-9]*" maxlength="9" inputmode="numeric" />
              </div>
            </div>

            <!-- Tercera fila: URL de LinkedIn -->
            <div class="form-row">
              <div class="form-group">
                <label>URL de LinkedIn <span class="required-asterisk">*</span></label>
                <input type="url" name="linkedinUrl" [formControl]="$any(profileForm.get('linkedinUrl'))" class="form-input"
                  placeholder="https://www.linkedin.com/in/tu-perfil" pattern=".*www\.linkedin\.com.*" />
              </div>
            </div>

            <div class="change-password-link">
              <a href="#" class="password-link" (click)="onChangePassword(); $event.preventDefault()">Cambiar contraseña</a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Descripción Section -->
    <div class="section-container">
      <div class="section-header">
        <h2 class="section-title">Descripción</h2>
      </div>
      <div class="section-subtitle">Todos los campos con (*) son obligatorios</div>
      
      <div class="section-content edit-mode" *ngIf="profileForm">
        <div class="form-group full-width">
          <label>Ingresa una breve descripción sobre ti <span class="required">*</span></label>
          <textarea 
            [formControl]="$any(profileForm.get('description'))" 
            class="form-textarea"
            placeholder="MBA en Marketing y Management por la University of Miami y bachiller en Administración por la Universidad de Lima. Destaca por su visión estratégica e implementación de metodologías innovadoras como las de ROI Institute, Fearless Culture y Talent Assessments de Hogan, SHL y HBDI. Su experiencia incluye roles directivos en IBM y partner en Perú y Brasil de ROI Institute. Es directora ejecutiva en Materials Research & Technology y NDT Innovations, directora de Leadership Services de AMROP y directora ejecutiva de Innovazzone."
            rows="4">
          </textarea>
        </div>
      </div>
    </div>

    <!-- Logros y experiencia destacada Section -->
    <div class="section-container">
      <div class="section-header">
        <h2 class="section-title">Logros y experiencia destacada</h2>
      </div>
      <div class="section-subtitle">Todos los campos con (*) son obligatorios</div>
      
      <div class="section-content edit-mode" *ngIf="profileForm">
        <h3 class="subsection-title">Logros y/o experiencia destacada <span class="required">*</span></h3>
        <div class="numbered-list">
          <div class="numbered-item" *ngFor="let achievement of achievementsFormArray.controls; let i = index">
            <span class="number">{{ i + 1 }}.</span>
            <input type="text" class="numbered-input" [formControl]="$any(achievement)" placeholder="">
            <button type="button" class="remove-btn" (click)="removeAchievement(i)" *ngIf="achievementsFormArray.length > 1">×</button>
          </div>
        </div>
        <button type="button" class="add-btn" (click)="addAchievement()" *ngIf="achievementsFormArray.length < 5">+ Agregar logro</button>
        <div class="limit-info" *ngIf="achievementsFormArray.length >= 5">
          Máximo 5 logros permitidos
        </div>
      </div>
    </div>

    <!-- Datos curiosos Section -->
    <div class="section-container">
      <div class="section-header">
        <h2 class="section-title">Datos curiosos</h2>
      </div>
      <div class="section-subtitle">Todos los campos con (*) son obligatorios</div>
      
      <div class="section-content edit-mode" *ngIf="profileForm">
        <h3 class="subsection-title">Datos curiosos sobre ti <span class="required">*</span></h3>
        <div class="numbered-list">
          <div class="numbered-item" *ngFor="let fact of curiousFactsFormArray.controls; let i = index">
            <span class="number">{{ i + 1 }}.</span>
            <input type="text" class="numbered-input" [formControl]="$any(fact)" placeholder="">
            <button type="button" class="remove-btn" (click)="removeCuriousFact(i)" *ngIf="curiousFactsFormArray.length > 1">×</button>
          </div>
        </div>
        <button type="button" class="add-btn" (click)="addCuriousFact()" *ngIf="curiousFactsFormArray.length < 5">+ Agregar dato curioso</button>
        <div class="limit-info" *ngIf="curiousFactsFormArray.length >= 5">
          Máximo 5 datos curiosos permitidos
        </div>
      </div>
    </div>

    <!-- Especialidades Section -->
    <div class="section-container">
      <div class="section-header">
        <h2 class="section-title">Especialidades</h2>
      </div>
      <div class="section-subtitle">Todos los campos con (*) son obligatorios</div>
      
      <div class="section-content edit-mode" *ngIf="profileForm">
        <h3 class="subsection-title">Especialidades <span class="required">*</span></h3>
        <div class="numbered-list">
          <div class="numbered-item" *ngFor="let specialty of specialtyTagsFormArray.controls; let i = index">
            <span class="number">{{ i + 1 }}.</span>
            <input type="text" class="numbered-input" [formControl]="$any(specialty)" placeholder="">
            <button type="button" class="remove-btn" (click)="removeSpecialtyTag(i)" *ngIf="specialtyTagsFormArray.length > 1">×</button>
          </div>
        </div>
        <button type="button" class="add-btn" (click)="addSpecialtyTag()" *ngIf="specialtyTagsFormArray.length < 5">+ Agregar especialidad</button>
        <div class="limit-info" *ngIf="specialtyTagsFormArray.length >= 5">
          Máximo 5 especialidades permitidas
        </div>
      </div>
    </div>

    <!-- Botón de guardar para desktop -->
    <div class="desktop-save-container">
      <button class="btn-save-desktop" type="submit" [disabled]="profileForm.invalid">
        <i class="fa-solid fa-check"></i>
        Guardar cambios
      </button>
    </div>
  </div>
</form>

<!-- Footer fijo para móvil cuando está en modo edición -->
<div class="mobile-edit-footer">
  <button class="save-button" type="submit" [disabled]="profileForm.invalid" (click)="onSubmit()">
    <i class="fa-solid fa-check"></i>
    Guardar cambios
  </button>
</div>
